module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺类型名称"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.edit_name) ? _c('el-input', {
    attrs: {
      "placeholder": "店铺类型名称"
    },
    model: {
      value: (_vm.form.shop_type_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "shop_type_name", $$v)
      },
      expression: "form.shop_type_name"
    }
  }) : _c('el-input', {
    attrs: {
      "disabled": "true",
      "placeholder": "店铺类型名称"
    },
    model: {
      value: (_vm.form.shop_type_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "shop_type_name", $$v)
      },
      expression: "form.shop_type_name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型介绍"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.shop_type_comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "shop_type_comment", $$v)
      },
      expression: "form.shop_type_comment"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用"
    }
  }, [_c('el-switch', {
    attrs: {
      "name": "status",
      "on-text": "启用",
      "off-text": "禁用",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.backCancle
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitItemsActionConfirm
    }
  }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28f168b1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28f168b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/shopstypes/shoptypes_editor.vue
// module id = 2560
// module chunks = 0